import Message from "./BaseMessage";
import EventManager from "./EventManager";
import config from "./config";



class IframeMessage extends Message {
    constructor() {
        super()
        this.eventManager = new EventManager()
        window.addEventListener('message', (e) => {
            console.log("iframe 获取到 message====>", e, location.href)
            const { eventName, data } = e.data
            console.log("子iframe 获取到 message====>", e, eventName, data, location.href)
            if(eventName){
                this.eventManager.fire(eventName, data)
                this.eventManager.fire('allEvent', { eventName, data })
            }
        })
    }

    /*broadcast(eventName, data) {
        //iframe 也通过 sdk 发送广播

        //--如果当前是顶层iframe，遍历所有子iframe发送信息
        if (window.top === window) {
            EventManager.fireAllSubViews(eventName, data)
        } else { //如果非顶层iframe，把消息转发给顶层iframe
            //top.postMessage({eventName, data}, '*')
            EventManager.fireView(window.top, eventName, data)
        }
    }*/

    onBroadcastAll(cb){
        this.eventManager.addEventListener('allEvent', cb)
    }

    onBroadcast(eventName, cb) {
        //执行当前iframe所有广播监听
        this.eventManager.addEventListener(eventName, cb)
    }

    /*//考虑删除
    onSubViewEmitMessage(eventName, cb) {
        return this.onBroadcast(eventName, cb)
    }

    //考虑删除
    onSuperViewEmitMessage(eventName, cb) {
        return this.onBroadcast(eventName, cb)
    }*/

    //向特定视图发送消息 （使用onSuperViewEmitMessage方法接收消息）
    emitMessageToView(view, eventName, data = {}) {
        //console.log("子iframe 获取到发送msg",  view, eventName, data,location.href)
        const ifr = view.getElement()
        ifr &&
        ifr.contentWindow &&
        //this.fireView(ifr.contentWindow, eventName, data, 'superView')
        ifr.contentWindow.postMessage({
            eventName: Message.MSG_TO_SPECIFIED_VIEW,
            data: {
                id: view.id,
                eventName,
                data
            }
        }, '*')
    }

    //向父视图发送消息  emitMessageToSuperView
    emitMessageToSuperView(eventName, data = {}) {
        const contentWindow = window.parent
        if (window.parent !== window) {
            //this.fireView(contentWindow, eventName, data, 'subView')
            contentWindow.postMessage({
                eventName: Message.MSG_TO_SUPER_VIEW,
                data: {
                    id: config.iframeViewId,
                    eventName,
                    data
                }
            }, '*')
        }
    }
}

export default IframeMessage